import { StyleProp, StyleSheet, TextStyle, View, ViewStyle } from 'react-native';
import { Button as ButtonOriginal, ButtonProps } from 'react-native-paper';
import React, { PropsWithChildren } from 'react';
import { IconSource } from 'react-native-paper/lib/typescript/components/Icon';
import {Border, Color} from '@/GlobalStyles';
import {useTranslation} from "react-i18next";

export type ButtonsProps = PropsWithChildren<{
  contentStyle?: StyleProp<ViewStyle>;
  outerStyle?: StyleProp<ViewStyle>;
  withShadow?: boolean;
}> &
  ButtonProps;

const Button = React.forwardRef<View, ButtonsProps>((props: ButtonsProps, ref) => {
  const {
    children,
    contentStyle,
    outerStyle,
    buttonColor,
    withShadow = true,
    mode = 'contained',
    ...rest
  } = props;

  const { t } = useTranslation();

  let finalButtonColor = buttonColor;
  if (!buttonColor && mode === 'outlined') {
    finalButtonColor = Color.blanc;
  }

  return (
    <ButtonOriginal
      uppercase={true}
      contentStyle={[styles.btnContent, contentStyle]}
      style={[withShadow && mode !== 'text' ? styles.btnShadow : {}, outerStyle]}
      buttonColor={finalButtonColor}
      mode={mode}
      {...rest}
      ref={ref}
    >
      {t(children)}
    </ButtonOriginal>
  );
});

export default Button;

const styles = StyleSheet.create({
  btnContent: {
    paddingVertical: 5,
    borderRadius: Border.br_3xs,
    height: 48,
    flexDirection: 'row',
  },
  btnShadow: {
    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowOffset: {
      width: -10,
      height: 10,
    },
    shadowRadius: 40,
    elevation: 40,
    shadowOpacity: 1,
  },
});
